import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { Box, makeStyles } from '@material-ui/core';
import Switch from '../Switch';
import { EvaluationFieldProps } from '../../types/Evaluation';

const useStyles = makeStyles(theme => ({
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginLeft: theme.spacing(1.5),
  },
  label: {
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
  },
}), { name: 'SwitchInput' });

function SwitchInput({ name, control, label }: EvaluationFieldProps) {
  const classes = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <>
        <Box className={classes.label}>{label}:</Box>
        <Box className={classes.switchRow}>
          <span className={classes.label}>No</span>
          <Switch
            checked={value === 'Yes' || value === true}
            onChange={() => {
              const next = (value === 'Yes' || value === true) ? 'No' : 'Yes';
              onChange(next);
            }}
          />
          <span className={classes.label}>Yes</span>
        </Box>
        </>
      )}
    />
  );
}

export default memo(SwitchInput);
